import { IMainOptions } from "./interfaces"
import WrapBox from "../images/demo-pics/gyrosa_mains_wrapbox1.avif"
import MealBox from "../images/demo-pics/gyrosa_mains_mealbox1.avif"
import CalamariBox from "../images/demo-pics/gyrosa_mains_calamari_box.avif"
import LoadedBox from "../images/demo-pics/gyrosa_mains_loadedboxfries.avif"
import KidsBox from "../images/demo-pics/gyrosa_mains_kidsbox.avif"
import SaladPita from "../images/demo-pics/gyrosa_mains_salad&pita.avif"
import SaladProtein from "../images/demo-pics/gyrosa_mains_salad&protein.avif"
import ProteinChickenGyro from "../images/demo-pics/gyrosa_protein_chicken.avif"
import ProteinChickenSouv from "../images/demo-pics/gyrosa_protein_chicken_souvlaki.avif"
import ProteinCrispy from "../images/demo-pics/gyrosa_protein_cripsy_souvlaki.avif"
import ProteinBlamb from "../images/demo-pics/gyrosa_protein_beef+lamb.avif"
import ProteinFalafel from "../images/demo-pics/gyrosa_protein_falafel.avif"
import ProteinScrimps from "../images/demo-pics/gyrosa_protein_shrimp_souvlaki.avif"
import SideFetaFries from "../images/demo-pics/gyrosa_sides_feta_fries.avif"
import SideFries from "../images/demo-pics/gyrosa_sides_fries.avif"
import SideGarlicFries from "../images/demo-pics/gyrosa_sides_garlic_feta_fries.avif"
import SideRice from "../images/demo-pics/gyrosa_sides_rice.avif"
import SideGreek from "../images/demo-pics/gyrosa_sides_salad_greeksalad.avif"
import SideKale from "../images/demo-pics/gyrosa_sides_salad_kale_caesar.avif"
import SidePita from "../images/demo-pics/gyrosa_sides_pita&hummusjpg.avif"
import CalamariIndividual from "../images/demo-pics/gyrosa_individual_calamari.avif"
import WrapIndividual from "../images/demo-pics/gyrosa_individual_wrap1.avif"
import HalloumiIndividual from "../images/demo-pics/gyrosa_individual_halloumi.avif"
import CakeIndividual from "../images/demo-pics/gyrosa_lemoncake.avif"
import FetaIndividual from "../images/demo-pics/gyrosa_retail_feta.avif"
import OlivesIndividual from "../images/demo-pics/gyrosa_retail_olives.avif"
import PitaIndividual from "../images/demo-pics/gyrosa_retails_pita_bag.avif"
import TzatSauce from "../images/demo-pics/gyrosa_sauce_tzatziki.avif"
import GarlicSauce from "../images/demo-pics/gyrosa_sauce_garlicsauce.avif"
import HotSauce from "../images/demo-pics/gyrosa_sauce_hotsauce.avif"
import HummusSauce from "../images/demo-pics/gyrosa_sauce_hummus.avif"
import { TMenuOptionProps } from "./types"

export const MainOptions: Array<TMenuOptionProps> = [
  {
    title: "Wrap Box", 
    src: WrapBox,
    description: "The legendary Greek wrap. Your choice of deliciously marinated protein wrapped in fresh hot pita with tomatoes, onions, feta, fries and tzatziki sauce. Served with your choice of 2 sides."
  },
  {
    title: "Meal Box", 
    src: MealBox,
    description: "Marinated protein served with your choice of 2 sides and Greek imported pita."
  }
]

export const MainExtras:  Array<TMenuOptionProps> = [
  {
    title: "Calamari Box", 
    src: CalamariBox,
    description: "Lightly battered, crispy, tender calamari topped with red onions, a wedge of lemon and tzatziki sauce for dipping. Served with your choice of 2 sides."
  },
  {
    title: "Loaded Box", 
    src: LoadedBox,
    description: "Fries or rice. Your protein, smothered in tomato, onions, feta and tzatziki."
  },
  {
    title: "Kids Box", 
    src: KidsBox,
    description: "Protein of your choice, served with rice or fries, pita, and a juice box."
  },
]

export const SaladOptions: Array<TMenuOptionProps> = [
  {
    title: "Salad & Pita", 
    src: SaladPita,
    description: "Greek or spring mix Caesar salad and a hot grilled pita."
  },
  {
    title: "Salad & Protein", 
    src: SaladProtein,
    description: "Greek or spring mix Caesar salad with your choice of protein."
  },
]

export const ProteinOptions: Array<TMenuOptionProps> = [
  {
    title: "Chicken Gyro",
    src: ProteinChickenGyro,
    description: "Overnight marinated, hand stacked chicken thigh. Slowly cooked on a vertical rotating spit in front of an open flame. Gluten Free."
  },
  {
    title: "Beef & Lamb Gyro",
    src: ProteinBlamb,
    description: "Beef and lamb mixed with our signature spice blend. Slowly cooked on a vertical rotating spit in front of an open flame. Gluten-free and halal."
  },
  {
    title: "Chicken Souvlaki",
    src: ProteinChickenSouv,
    description: "Overnight marinated chicken. Skewered and grilled to perfection. Gluten-free."
  },
  {
    title: "Crispy Chicken",
    src: ProteinCrispy,
    description: "The same chicken skewer but this time it's hand-battered and fried. Crispy on the outside, tender and juicy on the inside. Gluten-free and delicious."
  },
  {
    title: "Shrimp Souvlaki",
    src: ProteinScrimps,
    description: "5 marinated shrimp, skewered and cooked to order. Gluten-free."
  },
  {
    title: "Falafel",
    src: ProteinFalafel,
    description: "Fresh, made in house daily. Blended chickpeas, garlic, spices, onions, parsley, and cilantro. Gluten-free and vegan."
  },
]

export const SideOptions: Array<TMenuOptionProps> = [
  {
    title: "Gyrosa Fries",
    src: SideFries,
    description: "Fries cooked to order, tossed with Gyrosa's blend of Greek herbs, seasoning salt and lemon."
  },
  {
    title: "Feta Fries",
    src: SideFetaFries,
    description: "Our signature fries topped with feta cheese."
  },
  {
    title: "Garlic Feta Fries",
    src: SideGarlicFries,
    description: "Our feta fries with a garlicy twist. Garlic sauce and feta drizzled over fries. Your newest addiction."
  },
  {
    title: "Rice",
    src: SideRice,
    description: "Flavorful rice cooked in veggie stock, with Greek herbs, spices and olive oil. Gluten Free."
  },
]

export const SideExtras: Array<TMenuOptionProps> = [
  {
    title: "Pita",
    src: SidePita,
    description: "Greek imported pita with tzatziki or hummus for dipping."
  }
]

export const SideSalads: Array<TMenuOptionProps> = [
    {
    title: "Greek Salad",
    src: SideGreek,
    description: "Tomatoes, cucumbers, green peppers and onions. Lightly dressed in an olive oil Greek dressing. Topped with feta and olives."
  },
  {
    title: "Spring Mix Salad",
    src: SideKale,
    description: "Spring mix leafy greens lightly tossed in caesar dressing. Topped with freshly grated Myzithra cheese."
  },
]

export const IndividualItems: Array<TMenuOptionProps> = [
  {
    title: "Calamari",
    src: CalamariIndividual,
    description: "Lightly battered, crispy, tender calamari topped with red onions and tzatziki sauce for dipping."
  },
  {
    title: "Wrap",
    src: WrapIndividual,
    description: "The legendary Greek wrap. Your choice of deliciously marinated protein wrapped in fresh hot pita with tomatoes, onions, feta, fries and tzatziki sauce"
  },
  {
    title: "Halloumi",
    src: HalloumiIndividual,
    description: "Imported Halloumi cheese from Cyprus. Crispy, fried and hand battered. Drizzled with balsamic glaze, garlic sauce and pomegranate seeds."
  },
]

export const SweetsTreats: Array<TMenuOptionProps> = [
  {
    title: "Lemon Cake",
    src: CakeIndividual,
    description: "Our house made signature dessert. The Gyrosa Lemon Olive Oil Cake. Made with real lemon and olive oil."
  },
]

export const Sauces: Array<TMenuOptionProps> = [
  {
    title: "Tzatziki",
    src: TzatSauce,
    description: "House made Tzatziki following our own family recipe. Greek yogurt with cucumber, garlic, olive oil, and spices."
  },
  {
    title: "Garlic Sauce",
    src: GarlicSauce,
    description: "Creamy Garlic Sauce made fresh in-house. A whipped dipping sauce made from Greek yogurt, garlic, and lemon."
  },
  {
    title: "Hot Sauce",
    src: HotSauce,
    description: "Greek yogurt infused with harrisa and habaneros. Crafted with strong garlic notes to compliment the heat."
  },
  {
    title: "Hummus",
    src: HummusSauce,
    description: "Fresh Hummus made daily from chickpeas, cilantro, garlic, olive oil, and spices."
  },
]

